var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "switching_unit",
    class: [{
      switching_unit_fixed: _vm.isSearchFixed
    }, {
      switching_unit_height: _vm.isSearchFixed
    }]
  }, [_vm.loading ? _c('div', {
    staticClass: "iw-loader-mask"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e(), _c('div', {
    staticClass: "title",
    class: {
      'title-opacity': _vm.isSearchFixed
    }
  }, [_c('p', {
    staticClass: "font-label text-xs tracking-[0.3em] text-iw-secondary mb-4 uppercase"
  }, [_vm._v(` ${$t("pfhsqrd", "Step 2 · 选择单位")} `)]), _c('h1', {
    staticClass: "text-4xl font-headline tracking-tight text-iw-on-background mb-4"
  }, [_vm._v(` ${$t("e3xsmr4", "欢迎回来")} `)]), _c('p', {
    staticClass: "font-body text-sm text-iw-on-surface-variant max-w-2xl mx-auto leading-relaxed"
  }, [_vm._v(` ${$t("9w3paiv", "请选择下方的单位 — 点击整行直接进入，点击箭头展开查看下级。")} `)])]), _c('div', {
    staticClass: "search-actions",
    class: {
      'search-actions-fixed': _vm.isSearchFixed
    }
  }, [_c('div', {
    staticClass: "iw-search-bar flex-1"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-400 text-[18px] mr-2.5"
  }, [_vm._v("search")]), _c('Input', {
    staticClass: "search_input",
    attrs: {
      "placeholder": $t("amxppwe", "请输入单位代码或单位名称检索"),
      "clearable": ""
    },
    model: {
      value: _vm.searchObj.search,
      callback: function ($$v) {
        _vm.$set(_vm.searchObj, "search", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "searchObj.search"
    }
  })], 1), _c('button', {
    staticClass: "iw-action-btn hidden sm:flex",
    on: {
      "click": _vm.expandAll
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[16px]"
  }, [_vm._v("unfold_more")]), _c('span', [_vm._v($t("avb5xn4", "全部展开"))])]), _c('button', {
    staticClass: "iw-action-btn hidden sm:flex",
    on: {
      "click": _vm.collapseAll
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[16px]"
  }, [_vm._v("unfold_less")]), _c('span', [_vm._v($t("avc62w4", "全部折叠"))])]), _vm._alreadyUnit ? _c('button', {
    staticClass: "iw-action-btn",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onBack.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[16px]"
  }, [_vm._v("arrow_back")]), _c('span', [_vm._v($t("oxvu2", "返回"))])]) : _c('button', {
    staticClass: "iw-action-btn",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onLogout.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[16px]"
  }, [_vm._v("logout")]), _c('span', [_vm._v($t("iifi5w4", "退出登录"))])])]), _c('div', {
    staticClass: "filter-tabs"
  }, [_c('div', {
    staticClass: "filter-tabs__list"
  }, [_c('button', {
    staticClass: "iw-filter-tab",
    class: {
      active: _vm.activeFilter === 'ALL'
    },
    on: {
      "click": function ($event) {
        return _vm.setFilter('ALL');
      }
    }
  }, [_c('span', [_vm._v($t("av9jq04", "全部单位"))]), _c('span', {
    staticClass: "iw-filter-count"
  }, [_vm._v(_vm._s(_vm.allUnitCount))])]), _c('button', {
    staticClass: "iw-filter-tab",
    class: {
      active: _vm.activeFilter === 'FAVORITES'
    },
    on: {
      "click": function ($event) {
        return _vm.setFilter('FAVORITES');
      }
    }
  }, [_c('span', [_vm._v($t("cv51d84", "我的收藏"))]), _c('span', {
    staticClass: "iw-filter-count"
  }, [_vm._v(_vm._s(_vm.favoriteCount))])]), _c('button', {
    staticClass: "iw-filter-tab",
    class: {
      active: _vm.activeFilter === 'RECENT'
    },
    on: {
      "click": function ($event) {
        return _vm.setFilter('RECENT');
      }
    }
  }, [_c('span', [_vm._v($t("dlfjq84", "最近访问"))]), _c('span', {
    staticClass: "iw-filter-count"
  }, [_vm._v(_vm._s(_vm.recentCount))])])]), _vm._m(0)]), _vm.recentUnits.length > 0 ? _c('div', {
    staticClass: "recent-strip"
  }, [_c('p', {
    staticClass: "font-label text-[10px] text-iw-on-surface-variant tracking-widest uppercase mb-2.5"
  }, [_vm._v(` ${$t("dlfjq84", "最近访问")} `)]), _c('div', {
    staticClass: "recent-chips"
  }, _vm._l(_vm.recentUnits, function (unit) {
    return _c('button', {
      key: unit.unitId,
      staticClass: "recent-chip",
      on: {
        "click": function ($event) {
          return _vm.onRecentUnitClick(unit);
        }
      }
    }, [_c('span', {
      staticClass: "recent-chip__name"
    }, [_vm._v(_vm._s(unit.name))]), unit.code ? _c('span', {
      staticClass: "recent-chip__code"
    }, [_vm._v(_vm._s(unit.code))]) : _vm._e()]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [!_vm._unitIsNone ? _c('div', {
    staticClass: "tree-wrapper"
  }, [_c('ProTree', {
    attrs: {
      "data": _vm.filteredTreeData,
      "favoriteUnitIds": _vm.favoriteUnitIds
    },
    on: {
      "on-change": _vm.onChangeUnit,
      "toggle-favorite": _vm.onToggleFavorite
    }
  })], 1) : _vm._e(), _vm._unitIsNone ? _c('div', {
    staticClass: "empty-state"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-300 text-[48px] mb-3"
  }, [_vm._v("search_off")]), _c('p', {
    staticClass: "font-headline text-lg text-iw-on-surface mb-1"
  }, [_vm._v(` ${$t("dngd4z7", "没有查询到单位")} `)])]) : _vm._e()])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center space-x-2 text-iw-on-surface-variant"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[16px]"
  }, [_vm._v("account_tree")]), _c('span', {
    staticClass: "font-label text-[11px] tracking-widest uppercase"
  }, [_vm._v($t("gima204", "组织层级"))])]);
}];
export { render, staticRenderFns };